const messages = {
  information: 'Information',
  close: 'Close',
  changeRequest: 'Change request',
  status: 'Status',
  date: 'Date',
  recruitmentStatus: 'Recruitment status',
  wildtype: 'Wildtype',
  result: 'result',
  mutated: 'Alteration',
  results: 'Results',
  logout: 'Logout',
  langAbbrev: 'en',
  yes: 'yes',
  no: 'no',
  foundStudies: 'Studies found',
  favourites: 'favourites',
  impressum: 'Impressum',
  privacyStatement: 'Privacy statement',
  // Short label for the privacy link, used in the footer below the mobile
  // breakpoint where the full label does not fit
  privacyStatementShort: 'Privacy',
  osmAttribution:
    'Geographical Info (coordinates) provided by © OpenStreetMap contributors',
  hiddenOnes: 'Archived',
  visibleOnes: 'Normal',
  all: 'All',
  validated: 'Validated',
  notValidated: 'Not validated',
  reqRevalid: 'Requires revalidation',
  select: 'Select',
  noStudiesFound: 'No studies found',
  noStudiesInFavourites: 'No studies in favourites list',
  back: 'Back',
  edit: 'Edit',
  city: 'City',
  state: 'State',
  country: 'Country',
  save: 'Save',
  cancel: 'Cancel',
  apply: 'Apply',
  hidden: 'archived',
  visible: 'normal (not archived)',
  author: 'Author',
  of: 'of',
  unknown: 'unbekannt',
  district: 'Gebiet',
  confirm: 'Confirm',
  user: 'Nutzer',
  role: 'Role',
  inclusion: 'inclusion',
  exclusion: 'exclusion',
  andMore: '... and more',
  and: 'and',
  or: 'or',
  around: 'around',
  clickConfirmToApplyChanges:
    'Um Bestätigungen wirksam zu machen, bitte auf "Änderungen übernehmen" in der oberen Leiste klicken',
  manageTrackingConsent: 'Manage cookie consent',
  topMenuBox: {
    newStudy: 'Create new study',
    favorites: 'Favourites',
    allStudies: 'Study overview',
    changeRequests: 'Change requests',
    myChangeRequests: 'My change requests',
    patientDocs: 'How to use CATS',
  },
  tableView: {
    adaptTableColumns: 'Adjust table view',
    tableViewTooltip:
      'Which information to include in the table showing all studies',
    resultsPerPage: 'per page',
    resetTooltip: 'Reverts view back to standard selection.',
    modalTitle: 'Table view',
    modalInfoText: 'Please select the columns to be displayed',
    reset: 'Reset',
    deselectAll: 'Deselect all',
    selectAll: 'Select all',
    done: 'Ok',
    chooseOneTooltip: 'Please select at least one column',
    useBriefTitle: 'Use brief study title',
    useOfficialTitle: 'Use official study title',
  },
  trialsList: {
    searchErrorTitle: 'Search failed',
    searchErrorText:
      'The study list could not be loaded. Please try again.',
    titleSearchInfoText:
      'Your input will be searched in the official as well as the brief titles',
    titleSearchInfoTooltip:
      'If the desired title is not visible, try switching between original and brief titles',
    openSourceInNewTab: 'Open source page in new tab',
    tumorcategory: 'Tumor category',
    searchInputPlaceholder: 'Search titles...',
    title: 'Title',
    briefTitle: 'Brief title',
    originalTitle: 'Original title',
    officialTitle: 'Official title',
    subtype: 'Subtype',
    geneWild: 'Gene (wildtype)',
    geneMutated: 'Gene (altered)',
    variant: 'Variant',
    lineOfTherapy: 'Line of therapy',
    tmb: 'Mutational burden',
    locations: 'Locations',
    lastChange: 'Last changed',
    validated: 'Validated',
    diagnose: 'Diagnosis',
    diagnoses: 'Diagnoses',
    adjuvant: 'Adjuvant',
    biomarker: 'Biomarker',
    pathway: 'Pathway',
    tumorentity: 'Tumor entity',
    tumorregion: 'Tumor region',
    uicc: 'UICC',
    intervention: 'Intervention',
    addToFavourites: 'Add study to list of saved studies',
    addToFavouritesShort: 'Add to favourites',
    studyAddedToFavourites: 'Study added to list of saved studies',
    removeStudyFromFavourites: 'Remove study from list of saved studies',
    removedStudyFromFavourites: 'Removed study from personal list',
    removeStudyFromFavouritesShort: 'Remove from favourites',
    copiedStudySourceLinkToClipboard:
      'Link to study in source system copied to clipboard',
    copiedSearchLinkToClipboard: 'Link to search copied to clipboard',
    copiedLink: 'Link copied',
    checkedAndValidated: 'Study has been checked and validated',
    needsRevalidation:
      'Study was validated and has since been edited, revalidation is required',
    studyNotChangedThreshold:
      'This study has not been changed for at least 30 days',
    studyNotValidated:
      'Study has not been validated yet. The information my be unreliable and/or out of date',
    sortingToolTip:
      'Click toggles between ascending and descending sorting of results.',
    titleToggleTooltip:
      'Switch between brief and official title. If no brief title is given for a study, the official title is displayed instead.',
  },
  filter: {
    filterProfiles: {
      modal: {
        saveFilterProfileModalTitle: 'Create new filter profile',
        saveFilterProfileModalMessage:
          'Saves the current search for later reuse. Enter a name for the new search profile. If left empty, the current date and time will be used.',
        saveFilterProfileModalMessageEnterDifferentName:
          'Please choose a different name for the filter profile. Your previous choice is already in use.',
        inputPlaceholder: 'Profile name',
      },
      dropdownBtnLabel: 'Saved searches',
      tooltips: { deleteProfile: 'Delete filter profile' },
      filterProfileTable: {
        remove: 'Remove',
        name: 'Profile',
      },
    },
    activeFilters: 'Active filters',
    collapseActiveFilters: 'Collapse active filters',
    expandActiveFilters: 'Expand active filters',
    filterCategoryTabs: {
      general: 'General',
      clinical: 'Clinical',
      genetic: 'Genetic',
    },
    biomarkerPopupOpenBtnText: 'Select biomarkers',
    exclusionCriterionTagTooltip: 'exclusion criterion',
    inclusionCriterionTagTooltip: 'inlusion criterion',
    advancedSearch: 'Advanced search',
    standardSearch: 'Standard search',
    excludeSetByParentCategory:
      'This diagnosis filter has been auto generated by selecting a parent category. The inclusion / exclusion status of that category determines the status of this filter, which is why this dropdown is disabled.',
    filterTags: {
      expandBtnText: 'show more',
      collapseBtnText: 'show less',
      showHiddenStudies: 'Visibility',
      onlyHidden: 'Only archived ones',
      all: 'All',
      showValidatedStudies: 'Validation',
      onlyNonValidated: 'Only non-validated',
      onlyValidated: 'Only validated',
      onlyReqRevalid: 'Only revalidation required',
      locationName: 'Institution',
      location: 'Location',
    },
    showOnlyGeneticallyStratifiedTrialsFilterTag:
      'Genetically stratified studies',
    showOnlyGeneticallyStratifiedTrials:
      'Show only genetically stratified studies',
    showOnlyGeneticallyStratifiedTrialsTooltip:
      'Show only studies that have been annotated with at least one genetic alteration or one variant',
    proteinChange: 'Protein change',
    proteinChangePlaceholder: 'e.g. V600E',
    autoCreatedBySelectionOf: 'Automatically created due to selection of',
    removeParentCategoryTooltip:
      'Can represent multiple diagnoses. Removing this category also removes all diagnoses that have been automatically added by selected this category. Such diagnosis filters are marked accordingly.',
    showFilterOptions: 'Show filter options',
    hideFilterOptions: 'Hide filter options',
    resetFilter: 'Reset filter',
    filterOptions: 'Filter options',
    mainFilterTooltip: `When selecting multiple filters of the same category (e.g. "Locations") these are either linked with the logical operator "OR"
or the operator "AND". The link between categories is always "AND" (e.g. recruitment status *and* Locations).

Logical connection: Values that are linked with "OR" are grouped together.

Example: A *and* (B *or* C)
*and* D. To group values linked with "AND" together, (Example: (A *and* B)
*or* C), enter them like this: (Example: (A
*or* C) *and* (B *or* C)
            
Explanation for **Criterion A "AND" criterion B**: A study has to meet criterion A as well as criterion B, in order to be found.

Explanation for **Criterion A "Or" criterion B**: A study has to meet criterion A or criterion B (or both), in order to be found.`,
    mainFilterTooltipSimplified: `When selecting multiple filters of the same category (e.g. "Locations"),
results correspond to at least one of these filters.

When selecting multiple filters of different categories (e.g. "Locations" and "Diagnosis"),
results match all selected categories.`,
    saveFilterPofileTooltip:
      'Save the current filter settings as profile that can be easily reapplied later on',
    filterModeTooltip: `The **standard search** offers quick and easy entry of filter criteria. All criteria are interpreted as _inclusion criteria_.

The **advanced search** supports more sophisticated searches by providing a more flexible Interface.`,
    generalCriteria: 'General filter criteria',
    generalCriteriaPatientView: 'Location based search',
    simpleModeTooltip: `General filter criteria are automatically linked together with the logical operator "OR".`,
    patientModeTooltip: 'Location based filter criteria.',
    hiddenCriteriaTooltip: `Studies not considered relevant are usually archived. This option allows to display those, too.`,
    hiddenCriterionTitle: 'Show arch&shy;ived stu&shy;dies',
    openAdvancedSearch: 'Switch to advanced search',
    saveFilterProfile: 'Save filter profile',
    openSimpleSearch: 'Switch to standard search',
    validationStatus: 'Va&shy;li&shy;da&shy;tion sta&shy;tus',
    validationStatusTooltip: `Some studies have not yet been validated and therefore have to be examined by qualified users. This applies e.g. to studies that were recently added to the data base. This options allows to specifically search for such studies.`,
    statusTooltip: `Filter by recruitment status. When multiple options are chosen, those are linked with "OR".

Example: "Recruiting" *or* "Active not recruiting"`,
    locations: 'Stu&shy;dy lo&shy;ca&shy;tions',
    facilities: 'In&shy;vol&shy;ved Fa&shy;ci&shy;li&shy;ties',
    locationsTooltipSimple: `Search by the name of involved facilities, such as hospitals.`,
    locationsTooltipAdvanced: `Search by the name of involved facilities, such as hospitals.
    When selecting multiple options, you can choose if they are to be linked using "OR" or "AND".`,
    facilitiesTooltipSimple: `Filter for involved cities.`,
    facilitiesTooltipAdvanced: `Filter for locations (by selecting cities or entering free text).
    When selecting multiple options, you can choose if they are to be linked using "OR" or "AND".`,
    facilityNamePlaceholder: 'Name of the faciliy',
    selectCityPlaceholder: 'Select city',
    identifierPlaceholder: 'Study identifier e.g. NCT12345678',
    identifierTooltip: `Search a study by its unique identifier. The input has to match the identifier exactly.`,
    identifierImportButton: 'Import study',
    clinicalFilterCriteria: 'Clinical inclusion criteria',
    clinicalFilterCriteriaTooltip: `Search for clinical characteristics of the studied group. When selecting multiple options, they are linked with the logical "AND". An exception to this rule is the category 'diagnose', whose values are linked "OR"`,
    clinicalFilterCriteriaTooltipSimplified:
      'Search for clinical characteristics of the studied group. When selecting multiple filters of the same category, they are linked so that results match all selected filters. An exception to this rule is the category "diagnose".',
    diagnose: 'Di&shy;ag&shy;no&shy;sis',
    intervention: 'In&shy;ter&shy;ven&shy;tion',
    subtype: 'Sub&shy;type',
    tumorentity: 'Tu&shy;mor&shy; en&shy;ti&shy;ty',
    tumorregion: 'Tu&shy;mor reg&shy;ion',
    tumorcategory: 'Tu&shy;mor ca&shy;te&shy;go&shy;ry',
    tumorregionPlaceholder: 'e.g. Pancreas',
    tumorcategoryPlaceholder: 'e.g. solid tumors',
    tumorentityPlaceholder: 'e.g. Connective tissue',
    biomarkerPlaceholder: 'e.g. EBV',
    uiccPlaceholder: 'e.g. IA',
    subtypePlaceholder: 'e.g. GIST',
    interventionPlaceholder: 'e.g. Cisplatin',
    diagnosePlaceholder: 'z.B. C25 - Malignant neoplasm of pancreas',
    clinicalAndGeneticCriteria: 'Clinical and genetic filter criteria',
    clinicalAndGeneticCriteriaTooltip: `Filter for by characteristics of the examined groups.
    When selecting multiple options, you can choose if they are to be linked using "OR" or "AND".`,
    geneticCriteria: 'Genetic inclusion criteria',
    geneticCriteriaTooltip: `Filter by genetic characteristics of the examined groups.
     When selecting multiple options, you can choose if they are to be linked using "OR" or "AND".`,
    geneWild: 'Gene (wild&shy;type)',
    genePlaceholder: 'e.g. BRCA1',
    geneMutated: 'Genetic al&shy;te&shy;ra&shy;tion)',
    tmb: 'Tu&shy;mor mu&shy;ta&shy;tio&shy;nal bur&shy;den',
    tmbPlaceholder: 'e.g. medium',
    lineOfTherapy: 'Line of The&shy;ra&shy;py',
    lineOfTherapyPlaceholder: 'e.g. 2',
    adjuvantPlaceholder: 'yes/no',
    changeCategory: 'Choose category',
    pathway: 'Pathway',
    biomarker: 'Biomarker',
    uicc: 'UICC',
    adjuvant: 'Adjuvant',
    perimeterSearch: 'Perimeter',
    geolocationTooltipTooltip:
      'Based on your or another chosen location, it is possible to only show studies within a given radius of that position.',
    locateMe: 'Locate me',
    myCoordinates: 'My coordinates',
    lat: 'Latitude',
    lon: 'Longitude',
    advancedFunctionalityNotCompleteWarning:
      'Use this mode with caution. Full functionality has not yet been implemented and results are unreliable when using gene filters (alteration / wildtype). In case of problems, please use the standard serach for the time being.',
    variantPlaceholder: 'Variant',
  },
  tmb: { high: 'High', medium: 'Medium', low: 'Low' },
  settings: {
    changeHistoryColSelectionHeader: 'Change history',
    changeHistoryColSelectionTooltip:
      'Choose which columns the change history table should display in the details view',
    changeHistoryColSelectionExplMsg:
      'Individual selection of the information displayed',
    fontSizeAdjustMsg: 'Font size',
    fontSizeAdjustTooltip: `Changing the font size also changes the size of part of the web tool's components. Therefore, when choosing very large or small values, the layout may be compromised.`,
    fontSizeAdjustExplMsg: 'Customize text display',
    fontSizeExampleText:
      'Example text: This text helps to visualize the changes in font size.',
    fontSize: 'Font size',
    settings: 'Settings',
    small: 'Small',
    normal: 'Standard',
    medLarge: 'Medium large',
    large: 'Large',
  },
  details: {
    patientView: {
      studyDetails: 'Study details',
      contactInformation: 'Contacts',
      mutatedGenes: 'Genetic alterations',
      interventions: 'Interventions',
      diagnoses: 'Diagnoses',
      studyLocations: 'Study locations',
      tooltips: {
        contactsEmptyDisabled: 'No contact information available',
        locationsEmptyDisabled: 'No location information available',
      },
    },
    archiveInfo:
      'Archiving a study affects all users. Archived studies no longer appear in the normal study list, but can be found by applying the filter for archived studies.',
    groupNamePlaceholder: 'Cohort name',
    saveErrorMsg:
      'Due to an error, the changes could not be saved. More information in the console. In case this happens again, please contact the CATS team with an error description.',
    titleInfoModal: {
      chooseTitle: 'Choose title',
      enterTitle: 'Empty titles are not allowed. Please enter a title.',
    },
    recruitmentStatusIndicator: {
      tooltips: {
        recruiting: 'Recruiting patients',
        caution:
          'Only recruiting patients under certain circumstances / restricted recruiting',
        notRecruiting: 'No patients are currently being recruited',
        unknown: 'Recruitment status unknown',
      },
    },
    recruitmentStatusSelector: {
      tooltips: {
        recruiting: 'Show only recruiting sites',
        caution: 'Show only sites with restricted recruiting',
        notRecruiting: 'Show only non-recruiting sites',
        unknown: 'Show only sites with unknown recruitment status',
        clickAgainToDeselect: 'Hint: Click again to disable filter',
      },
    },
    facilityStatusFilterLabel: 'Status filter',
    changeHistorySummary: {
      affectedField: 'Affected information',
      kindOfChange: 'Kind of change',
      newValue: 'New value',
      user: 'User',
      changeReason: 'Reason',
      changeConfirmed: 'Change confirmed',
      contact: 'Contact',
      site: 'Location',
      manual: 'Manual',
      automatic: 'Automatic',
      kindOfChangeShort: 'Kind',
      newValueShort: 'New',
      changeReasonShort: 'Reason',
      newSiteSuffix: 'New Site',
      changeConfirmedShort: 'Validated',
      confirmChangeBtnText: 'Validate',
      removeConfirmationBtnText: 'Remove Validation',
    },
    studyInfoLastChangedOn: 'Study information last changed on',
    groupInfoLastChangedOn: 'Group information last changed on',
    geneticInformation: 'Genetic information',
    chooseAction: 'Choose action',
    adjuvant: {
      adjuvantTrue: 'Adjuvant',
      adjuvantFalse: 'Non-adjuvant',
    },
    tryingToOpenDetailsWithInvalidChangeRequest:
      'Trying to open details view with invalid change request',
    shareStudyBtn: 'Share study',
    shareStudyBtnToast: {
      successTitle: 'Link copied',
      successMessage: 'Successfully copied link to this page to clipboard',
      failureTitle: 'Something went wrong',
      failureMessage:
        'Link to this page could not be copied to clipboard. Please check the console messages for more info.',
    },
    applyChangeRequestToast: {
      success: {
        title: 'Success',
        message: 'Suggested change successfully applied.',
      },
      failure: {
        title: 'Something went wrong',
        message:
          'Suggested change could not be applied. Please try again later and contact the support if the issue persists.',
      },
    },
    variant: 'Variant',
    newInterventionNotProcessed:
      'New intervention has not been processed correctly.',
    chooseValidationTag: 'Choose validation status',
    undoValidation: 'Invalidate',
    validate: 'Validate',
    reqRevalid: 'Requires revalidation',
    discardChanges: 'Discard changes',
    applyChanges: 'Apply changes',
    applyChangesDisabled:
      'Applying changes not possible, please check your entries for errors',
    fetchExistingTrial: 'Fetch an existing study from clinicalTrials.gov',
    enterIdentifierTooltip:
      'Please enter an NCT identifier with the pattern NCTxxxxxxxx (eight digits).',
    createByIdentifierTooltip: `Add study with matching identifier.`,
    generalInfo: 'General information',
    editChangeReason: 'Edit reason for change',
    entryBeforeChange: 'Entry prior to change',
    entryHasBeenNewlyAdded: 'Entry has been created',
    searchAvailableSystems: 'Search for available systems',
    additionalInfo: 'Additional Information',
    noAdditionalInfoEntered: 'Entered no additional information',
    studyVisibility: 'Study visibility',
    studyHidden: 'Study is archived',
    studyVisible: 'Study is visible (not archived)',
    studyIs: 'The study is',
    studyHiddenCommentLabel: 'Comment',
    studyInfoLastChanged: 'Study info last changed',
    additionalInfoTooltip:
      'Additional information concerning the study. When adding a new entry or changing an existing one, the current user is saved as author.',
    identifierChangeTooltip:
      'Existing identifier entries can only be edited by users with special permissions. In case of questions, please contact our support.',
    catsIdentifierToolTip:
      'The CATS-Identfier can not be changed, because it is created automatically.',
    titleChangeTooltip:
      'Title information can only be changed by users with special permissions. In case of questions, please contact our support.',
    copyLinkToClipboard: 'Copy link to clipboard',
    copyIdentToClipboard: 'Copy identifier to clipboard',
    copyidentToClipboardToastTitle: 'Identifier copied',
    copyidentToClipboardToastMsg: 'Copied trial identifier to clipboard',
    examinationDetails: 'Clinical focus',
    trialDetails: 'Trial details',
    conditionFocusTooltip:
      'Summary of all conditions and interventions of study groups / cohorts',
    characteristicAiTooltip:
      'This characteristic was added with the help of AI, validation is necessary.',
    characteristicAliasesTooltip:
      'These aliases represent alternative names of this concept.',
    diagnoseTooltip:
      'The relevant diagnoses of the examined groups are summarized here',
    interventions: 'Interventions',
    interventionsTooltip:
      'The interventions of the examined groups are summarized here',
    involvedFacilities: 'Involved facilities',
    locationTooltipEditMode: `
If you wish to **add** a facility: Enter its name in the search input and select it, if present. Repeat in order to add multiple facilities.

In order to **create** a facility, that is not yet present in the data base: If the desired facility doesn't appear in the list, click on
"create new facility" in the dropdown menu (appears when clicking on the search input).

In order to **remove** a facility from the study: Click on the bin symbol next to the entry.
`,
    enterFacilityNameSearch: "To search, enter facility's name",
    enterToSearch: 'Enter text to search',
    addFacility: 'Add a facility',
    createFacility: 'Create new facility',
    location: 'Location',
    receivedStatus: 'Received status',
    userStatus: 'Annotated status',
    searchStatus: 'Search for status',
    cohortDetails: 'Cohort details',
    addCohort: 'Add cohort',
    removeCohort: 'Remove cohort',
    cohort: 'Cohort',
    subtypes: 'Subtypes',
    genesWild: 'Genes (wildtype)',
    genesMutated: 'Genes (altered)',
    tmb: 'Tumor mutational burden',
    cohortLastChanged: 'cohort information last changed',
    deleteStudy: 'Delete study',
    id: 'ID code',
    commentPlaceholder: 'Comment',
    noInfo: 'No information available',
    noDataAvailable: 'No data available',
    furtherCategoriesWithoutData: '{count} further categories without data',
    openMapTooltip: 'Inspect on map',
    defaultEmptyName: 'No Information available',
    diagnosePlaceholder: 'Diagnoses (icd10)',
    ctStatusTooltip:
      'This status has been automatically received from clinicalTrials.gov and cannot be changed manually',
    userStatusTooltip:
      'This status is maintained by users and can differ from the automatically received status',
    changeReasonTooltip:
      'In order to apply the changes made in this window the study has to be saved afterwards.',
    deleteReason: 'Delete explanation',
    reasonForChange: 'Reason for edit',
    pointInTime: 'Time',
    automaticChange: 'Automatic change',
    newValue: 'New value',
    changesConfirmed: 'Change confirmed',
    addNewIntervention: 'Add new intervention',
    criterionFor: 'Criterion for',
    onlyOneEntryTooltip: 'This property may only have one entry',
    studyIdentifierDuplicate:
      'Data base already contains a study with the given identifier.',
    infoAutoReceived: 'Information automatically filled in so fas as possible',
    studyAdded: 'Study added',
    studyNotFoundIdentifier: 'Found no study with the given identifier',
    appliedNewStatus: 'Applied new status.',
    studyValidated: 'Study validated',
    revokedValidation: 'Study invalidated',
    revalidationRequested: 'Revalidation requested',
    unableToApplyStatus: 'Unable to apply new status.',
    deletionFailed: 'Deletion failed',
    deletionFailedMsg: `"Study could not be deleted because it is being referenced by other ressources, e.g. personal study lists."`,
    newInerventionNotProcessed:
      'New intervention has not yet been fully processed',
    pleaseSelectNewIntervention: 'Please select the new intervention',
    fromThisListIfNeeded: 'manually from the list of interventions, if needed.',
    mayNeedFewMinutes:
      'It may take a few minutes for the new intervention to appear in the list.',
    newIntervention: 'New intervention',
    addedSuccessFully: 'added successfully.',
    interventionAlreadyInList: 'Intervention already exists in the list.',
    couldNotBeAdded: 'could not be added. Reason',
    biomarkerIncomplete:
      'Incomplete information entered for at least one biomarker. Information may not have been saved.',
    loading: 'Loading...',
    changesSaved: 'Changes successfully saved to data base.',
    notSaved: 'Unable to save changes. Please check your input.',
    illegalStatusInputMsg: 'Please select a value for the recruitment status',
    deleteStudyQuestion: 'Do you really want do delete this study?',
    deleteStudyAlt:
      'Alternatively, you can archive the study. Archived studies are no longer displayed in the regular list, but can be found in the search using the corresponding filter.',
    hideStudyButton: 'Archive study',
    studyHiddenExpl:
      'Archived studies are no longer displayed in the regular list, but can be found in the search using the corresponding filter.',
    unableDeleteStudy: 'Unable to delete Study.',
    onlyOneIdentPerSystem:
      'There can only be one identifier for each system. Currently the following',
    systemsSupported: 'systems are supported',
    hideLastChanges: 'Hide last changes',
    showLastChanges: 'Show last changes',
    noStudyFoundIdentifier:
      'No study with the given identifier could be found.',
    lastChangedMsg:
      'The time shown here is at what time the last change was made to this record in CATS (by the update algorithm or manually). This time may deviate from the information in the external trial database (e.g. Clinicaltrials.gov), if other data fields have been changed which are not read out by CATS. CATS is automatically updated periodically.',
    contactInfoMsg:
      'Diese Kontaktdaten werden automatisch aus den Datenquellen erhoben und können aktuell nicht bearbeitet werden.',
    studyCreated: 'Study created',
    creationCancel: 'Cancel',
    changeRequestModal: {
      proposeStatusChange: 'Propose different status',
      changeRequestModalChangeInput: 'Proposal',
      sendChangeRequest: 'Send change proposal',
      sendChangeRequestForNewEntry: 'Send proposal for new entry',
      changeRequestModalTitle: 'Propose a change',
      changeRequestModalText:
        'Please enter the proposed changes and, ideally, provide a reason for the proposal.',
      reasonPlaceholder: 'Reason for proposal',
      changeRequestModalReasonInput: 'Reason',
      originalValue: 'Original value',
      proposeDeletion: 'Request deletion',
      newSite: 'New Site',
      briefTitle: 'Brief title',
      title: 'Title',
    },
    variantEdit: {
      proteinExchangeInputPlaceholder: 'Protein exchange code',
      submitBtnText: 'search',
      gene: 'Gen',
      proteinChange: 'Protein change',
    },
    showChangeRequests: 'Show open change requests',
    changeRequestObsoleteMessage:
      'The selected change request references information that cannot be found (anymore). Please check if it is indeed no longer relevant and if so, reject it.',
    cancelRequest: 'Cancel request',
  },
  locationCreation: {
    newFacility: 'Neue Einrichtung',
    enterFacilityData: 'Please enter the detils of the new facility',
    addFacilityCautionMsg: `Before creating a new facility, please make sure that it doesn't already exist. For this, you may use the standard location input and enther the name of the desired facility.`,
    addFacilitySimilarFound: `Similar fayilities have been found in the data base. If the desired one is among those, please select it.`,
    noAddressDetails: 'Keine Adressdetails',
    useExistingFacility: 'Use existing facility',
    chooseSimilarFacilityTooltip: `Please choose an existing facility in order to add it to the study.`,
    chooseSimilarFacilityTooltipConfirmation: `Add selected facility to study instead of the details entered by you.`,
    createNewFacility: 'Create new facility',
    createNewFacilityTooltip:
      'Create new facility in data base with your input and add it to the study',
    saveAndNewLocation: 'Save and create another one',
    saveAndClose: 'Save and close',
    successToastTitle: 'Created new facility',
    successToastMsg: 'Facility successfully created in data base.',
    failToastMsg:
      'Die Einrichtung konnte nicht erstellt werden. Überprüfen Sie bitte ihre Angaben und versuchen Sie es erneut.',
  },
  share: {
    shareSearch: 'Share search',
    sendMail: 'Send mail',
    copyLink: 'Copy link',
    urlTooLongTooltip:
      'Too many filter parameters. The url is too long for automatic sharing via email. Please copy the link and manually paste it into a mail.',
  },
  token: {
    copyToken: 'Copy token',
    copyTokenMsgTitle: 'token copied',
    copyTokenMsg: 'Keykloak token copied to clipboard',
  },
  cookieBanner: {
    infoMsg:
      "This website uses cookies - You can find more information in our privacy statement. Click 'Accept', to activate all cookies or click 'Decline', to reject all cookies that are not strictly necessary for the operation of this website.",
    acceptBtn: 'Accept',
    declineBtn: 'Decline',
    privacyBtn: 'Privacy statement',
  },
  contactDetails: {
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    contactPossibility: 'Contact',
    contactInformation: 'Contact information',
    noDetails: 'No contact details available',
    source: 'Source',
    unknown: 'Unknown',
    edit: {
      telecomSelectPlaceholder: 'category',
      addInfoHint: 'Click to add contact info',
    },
    contactDetailEdit: {
      tooltips: {
        removeTelecom: 'Remove contact opportunity (e.g. phone, e-mail)',
        addTelecom: 'Add contact opportunity (e.g. phone, e-mail)',
        addContactDetail: 'Add contact',
        removeContactDetail: 'Remove contact',
      },
      invalidContactPhoneInputMsg:
        'The entered phone number is invalid. Please use only digits and common special characters.',
      invalidContactMailInputMsg:
        "{ 'The entered email address is invalid. Expected format: name@example.suffix' }",
      emptyContactPhoneMsg: 'Please enter a phone number.',
      emptyContactMailMsg: 'Please enter an e-mail address.',
    },
    originTranslation: {
      catsFrontend: 'Manually added (via CATS Frontend)',
    },
  },
  tumorcategories: { solidTumors: 'Solid tumors' },
  error: {
    failedToLoadResource: 'Failed to load resource',
    copyClipboardError: 'Copying failed',
    notWorked: "That didn't work",
    changeRequestCouldNotBeLoaded: 'Change request could not be loaded',
    alreadyExists: 'Already exists',
    error: 'Error',
    errorDuringRequest: 'An error occurred while executing the request.',
    errorOccurred: 'There was a problem',
    geolocationFailedMsg:
      'Coordinates could not be applied. Please try again in a few minutes.',
    geolocationFailedCoordinatesDeliveryMsg:
      'The coordinates required for the perimeter search could not be determined.',
    couldNotRemoveStudyFromFavs: 'Could not remove study from favourites',
    couldNotAddStudyToFavs: 'Could not add study to favourites',
    //   warningOccurred: "Warnung",
    //   unauthorized: "Sie sind nicht berechtigt, diese Operation durchzuführen.",
    //   pageNotFound: "Seite nicht gefunden",
    //   pageNotFoundDescription: "Die angeforderte Seite konnte nicht gefunden werden. Bitte stellen Sie sicher, dass die Adresse korrekt ist."
  },
  changeRequestPage: {
    change: 'Change',
    tasks: 'Requests',
    heading: 'Change requests',
    userSpecificHeading: 'My change requests',
    noEntries: 'No open change requests found',
    requested: 'Requested',
    cancelled: 'Cancelled',
    completed: 'Completed',
    filterForStatus: 'Filter for status',
    confirmTaskCancellationModalMsg: 'Cancel selected change request?',
    lastUpdated: 'Last update',
    status: 'Status',
    changedInfoType: 'Concerned information',
    oldValue: 'Original value',
    newValue: 'Proposed value',
    changeReason: 'Reason',
    options: 'Options',
    studyTitle: 'Study title',
    targetTitlePlaceholder: 'Unavailable',
    changeRequestTaskStatusTranslations: {
      requested: 'Requested',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    affectedFields: {
      site: 'Location',
      'site status': 'Location status',
      contact: 'Contact',
      status: 'Recruitment status',
      title: 'Title',
      'brief title': 'Brief title',
    },
    toasts: {
      cancelFailure: {
        title: 'Status change failed',
        message: "Status of change request could not be set to 'cancelled'.",
      },
      cancelSuccess: {
        title: 'Status change successful',
        message: "Status of change request set to 'cancelled'.",
      },
      reActivationSuccess: {
        title: 'Status change successful',
        message: 'Change request marked as active.',
      },
      reActivationFailure: {
        title: 'Status change failed',
        message: 'Change request could not be reactivated.',
      },
      openError: {
        generalErrorMsg: 'Something went wrong',
        couldNotOpenStudyWithRequest:
          'Unable to open study page with change request information',
      },
    },
    tooltips: {
      reActivateTask: 'Reactivate change request',
      cancelTask: 'Cancel change request',
      requestNotActiveMsg: "Change request is not active and can't be opened.",
      newEntry: 'New entry',
      removal: 'Removal',
      change: 'Change',
    },
  },
  genericConfirmationModal: {
    header: 'Confirmation required',
  },
  changeRequestComponents: {
    modalOpenerTooltips: {
      add: 'Propose new entry',
      change: 'Propose change',
    },
    valueToBeAdded: 'Value to be added',
    proposedDeletion: 'Proposed deletion',
    proposedChange: 'Proposed change',
    changeRequest: 'Change request',
    accept: 'Accept proposal',
    reject: 'Reject proposal',
    valueAtTimeOfRequestCreation: 'Original value',
    suggestedValue: 'Suggested value',
    reason: 'Reason',
    timeOfRequest: 'Time of request',
    changedTargetWarning: {
      targetValueChanged:
        'Original value has been changed since change request was created',
      currentValue: 'Current value',
    },
  },
  substanceCreationModal: {
    title: 'Create new intervention',
    message:
      "If the desired intervention doesn't appear in the dropdown list, it can be created here.\nPlease enter the new intervention's name. The casing (but not spelling) may be changed to system standards during processing.",
    placeholder: 'Name of the new intervention',
    confirm: 'Confirm',
    cancel: 'Cancel',
    inputLabel: 'Name',
    infoMessage:
      'Attention: Interventions must be capitalized, this is automatically adjusted when they are created.',
  },
  changeRequestFeedbackToasts: {
    taskCreated: {
      title: 'Change request submitted',
      message:
        'Change Request has been successfully submitted and is now pending review.\nThank you for your participation.',
    },
    taskCreationFailed: {
      title: 'Submission failed',
      message: 'Change request could not be submitted due to an error',
    },
  },
  pwaInstallPrompt: {
    title: 'Add to desktop',
    message:
      'CATS can be installed and added to the desktop.Then it can be used like a regular app, instead of using the browser. Would you like to try it?',
    acceptBtn: 'Install CATS',
    declineBtn: "Decline and don't show again",
  },
  pwaUpdatePrompt: {
    message:
      'A new version of the app is available.\n\nRefresh to get new version (this will refresh all open tabs of this app)?\nIf the update is skipped, refreshing the page will cause this prompt to be shown again.',
  },
  fallbackPage: {
    title: 'OOPS! Looks like something went wrong...',
    errorAnouncement: 'The following error has been encountered',
    followingOptions: 'You have the following options',
    checkInternetConnection: 'Check your internet connection',
    refreshPage:
      'Refresh the page (try hard refreshing; depending on your browser, this could be something like holding shift and clicking the refresh button)',
    tryAgain: 'Try again later',
    tryDifferentBrowser: 'Try a different browser',
    contactSupportMail:
      'If none of the above work for you, feel free to contact',
    reopenBrowser: 'Close and reopen browser in order to reload the page',
  },
  sidebar: {
    filterOptions: 'Filter options',
    tableColumnSelection: 'Customize Table view',
    titleFormat: 'Change title format',
    collapse: 'Collapse',
  },
  biomarkerPopup: {
    modalTitle: 'Select biomarkers and their values to filter by',
    cancel: 'Cancel',
    apply: 'Apply',
    positive: 'Positive',
    negative: 'Negative',
    unknown: 'Unknown',
    notTested: 'Not tested',
  },
  LoincLL36393Answers: {
    'LA6576-8': 'Positive',
    'LA6577-6': 'Negative',
    'LA4489-6': 'Unknown',
    'LA13538-6': 'Not tested',
  },
  collapse: {
    showMore: 'Show more',
    showLess: 'Show less',
  },
};

export default messages;
